module.exports = __webpack_public_path__ + "static/red-0bb484c67f76f9368c34e4d2d4e17597.jpg";